import { render, staticRenderFns } from "./Salles.vue?vue&type=template&id=53a7582a&"
import script from "./Salles.vue?vue&type=script&lang=js&"
export * from "./Salles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports